module.exports = "/_next/static/images/b7bd47b235ea71f3f5ebff3c49bfb1d6-cartao-proximo-ao-olho-md@1x.jpg.webp";